<script>
export default {
	inheritAttrs: false,
	props: {
		index: Number,
		data: Object,
	},
	computed: {
		fluid() {
			const hasOneBanner = this.data.rows?.length == 1 && this.data.rows[0].banners.length == 1
			return (!this.$b.m && hasOneBanner) || this.data.fullWidth
		},
	},
}
</script>

<template>
	<Container :fluid="fluid" :class="{ '--mobile': $b.m }">
		<v-row v-for="(row, n) in data.rows" :key="n">
			<v-col
				:class="{ 'px-0': $b.m, first: n == 0, last: n == row.banners.length - 1 }"
				cols="12"
				:md="12 / row.banners.length"
				v-for="(banner, n) in row.banners"
				:key="n"
			>
				<BannerItem v-bind="banner" />
			</v-col>
		</v-row>
	</Container>
</template>

<style scoped lang="scss">
.container.--mobile ::v-deep img {
	border-radius: 0;
}
.container.container--fluid .first ::v-deep img {
	border-radius: 0 8px 8px 0 !important;
}
.container.container--fluid .last ::v-deep img {
	border-radius: 8px 0 0 8px !important;
}
.container.container--fluid .first.last ::v-deep img {
	border-radius: 0 !important;
}
</style>
